import axiosClient from "../../../../api/axiosClient";

// -----------------------------------------------------
// TENANTS
// -----------------------------------------------------

export const getTenants = async () => {

    const res = await axiosClient.get(
        "/tenant/api/list"
    );

    return res.data.data || [];

};

// -----------------------------------------------------
// LOCATIONS
// -----------------------------------------------------

export const getLocations = async (
    tenantId
) => {

    if (!tenantId) return [];

    const res = await axiosClient.get(

        "/tenant/api/locations",

        {
            params: {
                tenant_id: tenantId
            }
        }

    );

    return res.data.data || [];

};

// -----------------------------------------------------
// DEPARTMENTS
// -----------------------------------------------------

export const getDepartments = async (

    tenantId,

    locationId

) => {

    if (!tenantId) return [];

    const params = {

        tenant_id: tenantId

    };

    if (locationId) {

        params.location_id = locationId;

    }

    const res = await axiosClient.get(

        "/tenant/api/departments",

        {

            params

        }

    );

    return res.data.data || [];

};